import { mapActions } from 'vuex'
import FileSaver from 'file-saver'
import base64ToBlob from '@/helpers/base64ToBlob'
import { confirmation } from '@/utils/alert'

export default {
  ...mapActions(['loadProfessional']),
  doDelete (item, msg) {
    this.currentEntity = item
    const message = {
      label: 'Excluir',
      title: 'Atenção',
      message: msg,
      cancel: 'Cancelar'
    }

    confirmation(confirm => {
      if (!confirm) {
        return
      }

      this.doDeleteWithoutConfirmation(item)
    }, message.message, message.title, message.label, message.cancel)
  },
  doDeleteWithoutConfirmation (entity) {
    this.currentEntity = entity
    if (!this.beforeDelete(entity)) {

    }
    this.$http.delete('v1/professional/documents/' + entity.id)
      .then(({data}) => {
        this.afterDelete(entity, data)
        return this.$router.push({name: 'professional.company.documents.index'})
      })
  },
  downloadDocument (file) {
    this.$http.get('v1/professional/documents/' + file.id + '/download')
  .then(({data}) => {
    FileSaver.saveAs(new window.Blob([base64ToBlob(data.content)], {type: 'application/octet-stream'}), data.filename)
  })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/documents/form/resources/methods.js